import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import { LoginPage } from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { SuspendedPage } from './pages/SuspendedPage';
import OrderTab from './pages/OrderTab';
import MerchantApprovalTab from './pages/MerchantApprovalTab';
import ReportsTab from './pages/ReportsTab/SettlementReport';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        <Route path="/suspended" element={<SuspendedPage />} />

        {/* Protected routes */}
       
        <Route path="/profile" element={
          
            <Layout>
              <ProfilePage />
            </Layout>
       
        } />

        <Route path="/orders" element={
          
            <Layout>
              <OrderTab />
            </Layout>
       
        } />
        <Route path="/merchant-approval" element={
          
            <Layout>
              <MerchantApprovalTab />
            </Layout>
       
        } />
        <Route path="/settlement-report" element={
          
            <Layout>
              <ReportsTab />
            </Layout>
       
        } />

        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to="/unauthorized" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
